import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Post, ActivityPost, Pagination, ModeratedPost, PrivateContentReadModel} from '../models/post.model';
import { environment } from '../../../../../environments/environment';

import { Adal4Service, Adal4HTTPService } from 'adal-angular4';

@Injectable()
export class ActivityPostService {

    public postFeedAmount = 15;
    public pagination: Pagination;
    public firstPageParams = '?pageNumber=1&pageSize=' + this.postFeedAmount;
    private headers = new Headers({'Content-Type': 'application/json'});
    private baseUrl = environment.endpoints.activityPostModerateApi + this.firstPageParams;
    private privateContent = environment.endpoints.privateContentApi;
    private removePostUrl = environment.endpoints.activityPostRemovalApi;
    private removeCommentUrl = environment.endpoints.activityCommentRemovalApi;

    constructor(
        private http: Http,
        private adalService: Adal4Service,
        private authHttp: Adal4HTTPService,
    ) { }

    getBaseUrl() {
        return this.baseUrl;
    }

    getPosts(): Observable<Post[]> {
        return <Observable<Post[]>>this.http
            .get(this.baseUrl, this.getDefaultRequestOptions())
            .map(res => this.extractData<Post[]>(res));
    }

    getActivityPostFromApi(type?: string): Observable<ModeratedPost[]> {
        return <Observable<ModeratedPost[]>>this.http
            .get(this.baseUrl + type, this.getRequestOptionsArgs())
            .map(res => this.extractData<ModeratedPost[]>(res));
    }

    getPrivateContentFromApi(userId?: string, contentId?:string, privacy?:string, createdBy?:string): Observable<PrivateContentReadModel> {
        if(contentId !== ""){
        return <Observable<PrivateContentReadModel>>this.http
            .get(`${this.privateContent}/${userId}/moderator/${contentId}`, this.getRequestOptionsForPrivateContentArgs(privacy,createdBy))
            .map(res => this.extractPrivateData<PrivateContentReadModel>(res));
        }
    }

    getPrivateContentVideoFromApi(userId?: string, contentId?:string, privacy?:string, createdBy?:string): Observable<PrivateContentReadModel> {
        if(contentId !== ""){
        return <Observable<PrivateContentReadModel>>this.http
            .get(`${this.privateContent}/${userId}/moderator/${contentId}/activityfeed/videos`, this.getRequestOptionsForPrivateContentArgs(privacy,createdBy))
            .map(res => this.extractPrivateData<PrivateContentReadModel>(res));
        }
    }

    removePost(id: string): Observable<Response> {
        // console.log('== Post Removing ==');
        return this.http
            .post(this.removePostUrl + id, '', this.getRequestOptionsArgs())
            .map(res => this.extractResponse(res));
    }

    removeComment(id: string): Observable<Response> {
        // console.log('== Comment Removing ==');
        return this.http
            .post(this.removeCommentUrl + id, '', this.getRequestOptionsArgs())
            .map(res => this.extractResponse(res));
    }

    updateBaseUrl(url: string): void {
        this.baseUrl = url;
    }

    returnBaseUrl(): string {
        return this.baseUrl;
    }

    private extractResponse(res: Response): Response {
        console.log('== Response code == ' + res);
        if (res.status < 200 || res.status >= 300) {
            throw new Error('Bad response status: ' + res.status);
        }

        if (res.status === 401) {
            this.adalService.logOut();
        }

        return res;
    }

    private extractData<T>(res: Response) {
        res = this.extractResponse(res);
        this.pagination = JSON.parse(res.headers.get('x-pagination'));
        const body = res.json ? res.json() : null;
        // console.log('=== body ====' + JSON.stringify(body));
        return <T>(body || {});
    }

    private extractPrivateData<T>(res: Response) {
        res = this.extractResponse(res);
        const body = res.json ? res.json() : null;
        // console.log('=== body ====' + JSON.stringify(body));
        return <T>(body || {});
    }

    private getDefaultHeaders(): Headers {
        const headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Access-Control-Expose-Headers', 'x-pagination');
        return headers;
    }

    private getDefaultRequestOptions(): RequestOptionsArgs {
        let headers;
        headers = this.getDefaultHeaders();
        return {headers};
    }

    private handleError(error: Response) {
        // we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    private getBearerToken(): string {
        let token;
        // e677240f-d4f0-449c-90c3-aa29b92883ec --- api
        // 61894b77-80d1-49e3-9477-fffd428ec4eb --- web
        // console.log(this.adalService.config);
        this.adalService.acquireToken(environment.authentication.clientId).subscribe(act => token = act);
        // console.log('Bearer: ' + token);
        return token;
    }

    private getRequestOptionsArgs(): RequestOptionsArgs {
        const options = this.getDefaultRequestOptions();
        options.headers.append('Authorization', 'Bearer ' + this.getBearerToken());
        return options;
    }

    private getRequestOptionsForPrivateContentArgs(privacy:string, createdId:string): RequestOptionsArgs {
        const options = this.getDefaultRequestOptions();
        options.headers.append('Authorization', 'Bearer ' + this.getBearerToken());
        options.headers.append('X-RequestFromActivityFeed', 'true');
        options.headers.append('X-Privacy', privacy);
        options.headers.append('X-CreatedBy', createdId);
        options.headers.append('Access-Control-Allow-Origin','*');
        options.headers.append("Access-Control-Allow-Methods", "GET, POST, DELETE, PUT")
        options.headers.append("FromModerator","DFBC949A-B109-4785-9680-0E54CBFE52C9");
        return options;
    }

}



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/routes/home/socialboard/services/socialboard.service.ts